import WeatherMapSelect from '../../../../components/WeatherMapSelect/WeatherMapSelect';
import { useMemo } from 'react';
import { getSevereWeatherAlertAreaLabel } from '../../utils/severeWeatherAlerts.utils';

const SevereWeatherAlertAreaSelect = ({
  areas = [],
  selectedAreaId,
  onSelectArea,
  wrapperClassName = 'flex-shrink-0',
  label = 'Alert area',
  ariaLabel,
}) => {
  const areaOptions = useMemo(
    () =>
      areas.map((area) => ({
        value: area.id,
        label: getSevereWeatherAlertAreaLabel(area),
      })),
    [areas],
  );

  return (
    <WeatherMapSelect
      options={areaOptions}
      selectedValue={selectedAreaId}
      onChange={onSelectArea}
      wrapperClassName={wrapperClassName}
      label={label}
      ariaLabel={ariaLabel}
      placeholder="Search alert areas"
      noOptionsMessage="No alert areas found"
    />
  );
};

export default SevereWeatherAlertAreaSelect;
